import { render, staticRenderFns } from "./gridComponent.vue?vue&type=template&id=2b93f4ac&"
import script from "./gridComponent.vue?vue&type=script&lang=js&"
export * from "./gridComponent.vue?vue&type=script&lang=js&"
import style0 from "./gridComponent.vue?vue&type=style&index=0&id=2b93f4ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports